import { render, staticRenderFns } from "./employeesGroupSelect.vue?vue&type=template&id=28fc66b7&scoped=true&"
import script from "./employeesGroupSelect.vue?vue&type=script&lang=js&"
export * from "./employeesGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./employeesGroupSelect.vue?vue&type=style&index=0&id=28fc66b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc66b7",
  null
  
)

export default component.exports